/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Rating_EmmaInputs */

const en_onboarding_rating_emma = /** @type {(inputs: Onboarding_Rating_EmmaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The text-to-speech quality is remarkable. I can finally listen to my research papers while doing other tasks.`)
};

const es_onboarding_rating_emma = /** @type {(inputs: Onboarding_Rating_EmmaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La calidad del texto a voz es notable. Por fin puedo escuchar mis artículos de investigación mientras hago otras tareas.`)
};

/**
* | output |
* | --- |
* | "The text-to-speech quality is remarkable. I can finally listen to my research papers while doing other tasks." |
*
* @param {Onboarding_Rating_EmmaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_rating_emma = /** @type {((inputs?: Onboarding_Rating_EmmaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Rating_EmmaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_rating_emma(inputs)
	return en_onboarding_rating_emma(inputs)
});